/** The open tables list on the home screen (slice 0012, review 0024 decision 176: watching). */
export const tablesEn = {
  "rules.how": "How to play",
  "home.join": "Join",
  "home.joinTable": "Join {name}'s table",
  "home.seatsOpen": "{open} {open|seat|seats} open",
  "home.playing": "Playing now",
  "home.watch": "Watch",
  "home.watchTable": "Watch {name}'s table",
  "home.tables": "Open tables",
  "home.tables.empty": "No open tables right now. Set up yours and friends can join.",
  "home.filter.all": "All",
};

export const tablesTr = {
  "rules.how": "Nasıl oynanır?",
  "home.join": "Katıl",
  "home.joinTable": "{name} masasına katıl",
  "home.seatsOpen": "{open} boş koltuk",
  "home.playing": "Oynanıyor",
  "home.watch": "İzle",
  "home.watchTable": "{name} masasını izle",
  "home.tables": "Açık masalar",
  "home.tables.empty": "Şu an açık masa yok. Kendi masanı kur, arkadaşların katılsın.",
  "home.filter.all": "Tümü",
};

export const tablesAr = {
  "rules.how": "كيف تلعب؟",
  "home.join": "انضم",
  "home.joinTable": "انضم إلى طاولة {name}",
  "home.seatsOpen": "{open} {open|one:مقعد فارغ|two:مقعدان فارغان|few:مقاعد فارغة|other:مقعد فارغ}",
  "home.playing": "قيد اللعب",
  "home.watch": "شاهد",
  "home.watchTable": "شاهد طاولة {name}",
  "home.tables": "الطاولات المفتوحة",
  "home.tables.empty": "لا توجد طاولات مفتوحة الآن. جهّز طاولتك ليتمكن أصدقاؤك من الانضمام.",
  "home.filter.all": "الكل",
};
